//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { FulfillmentType } from '@apis/campaign-requests/sampling/campaign-requests/samplingCampaignRequestsApiModel';
import { SamplingDeliveryMethod } from '@apis/campaign-requests/sampling/opportunities/samplingOpportunitiesApiModel';
import {
  SamplingCampaignRequestSectionName,
  getSamplingCampaignSectionDisplayName,
} from '@campaigns/constants/sampling/SamplingCampaignRequestSectionConstants';
import { BodyText } from '@components/atoms/text/Text';

interface ChangePurchaseOptionConfirmationProps {
  fulfillmentType?: FulfillmentType;
  removedDataSection?: SamplingCampaignRequestSectionName;
  targetCampaignType?: SamplingDeliveryMethod;
}

export const ChangePurchaseOptionConfirmation = ({
  fulfillmentType,
  removedDataSection,
  targetCampaignType,
}: ChangePurchaseOptionConfirmationProps) => {
  const sectionName = removedDataSection
    ? getSamplingCampaignSectionDisplayName(removedDataSection, fulfillmentType)
    : undefined;

  return (
    <Container>
      <BodyText>
        Are you sure you want to change to a {targetCampaignType} campaign?
      </BodyText>
      {sectionName && (
        <>
          <BodyText>
            This will update Content settings and remove any data you have
            entered regarding {sectionName}.
            <br />
            <br />
            This action cannot be undone.
          </BodyText>
        </>
      )}
    </Container>
  );
};

const Container = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[4]};
`,
);
